import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAsAgoPipe } from './date-as-ago.pipe';



@NgModule({
  declarations: [
    DateAsAgoPipe
  ],
  exports: [
    DateAsAgoPipe
  ],
  imports: [
    CommonModule
  ]
})
export class DateAsAgoModule { }
